import { Component, EventEmitter, HostListener, input, InputSignal, OnInit, Output } from '@angular/core';
import { Column, ColumnType } from '@shared/components/simple-table/models/simple-table-model';
import { TableCellComponent } from '../table-cell/table-cell.component';
import { MatIconButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIcon } from '@angular/material/icon';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';
import { NgIf } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

const PHONE_BREAKPOINT = 480;

@Component({
    selector: 'app-mobile-table',
    templateUrl: './mobile-table.component.html',
    styleUrls: ['./mobile-table.component.scss'],
    imports: [TableCellComponent, MatIconButton, MatTooltip, MatIcon, MatMenuTrigger, MatMenu, MatMenuItem, NgIf, TranslatePipe]
})
export class MobileTableComponent implements OnInit {
  protected readonly ColumnType = ColumnType;

  columns: InputSignal<Column[]> = input<Column[]>([]);
  actions: InputSignal<any[]> = input<any[]>([]);
  data: InputSignal<any[]> = input<any[]>([]);

  @Output()
  action: EventEmitter<any> = new EventEmitter();

  isOpen = false;
  displayedColumns: Column[] = [];
  hidedColumns: Column[] = [];

  private get visibleCount(): number {
    return window.innerWidth <= PHONE_BREAKPOINT ? 1 : 2;
  }

  ngOnInit(): void {
    this.updateColumns();
  }

  @HostListener('window:resize')
  updateColumns(): void {
    const localColumns = [...this.columns()];
    this.displayedColumns = localColumns.splice(0, this.visibleCount);
    this.hidedColumns = localColumns;
  }

  onAction(action: any, row: any, index?: number): void {
    if (action.command) {
      action.command(row);
    }
    this.action.emit({ action, row, index });
  }
}
